import { render, staticRenderFns } from "./DrugsReceivedByMonthRep.vue?vue&type=template&id=bca01efa&"
import script from "./DrugsReceivedByMonthRep.vue?vue&type=script&lang=js&"
export * from "./DrugsReceivedByMonthRep.vue?vue&type=script&lang=js&"
import style0 from "./DrugsReceivedByMonthRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports